<template>
    <div class="ut-flex ut-flex-col ut-min-h-screen">
      <template v-if="isPremier">
        <section class="ut-w-full ut-px-4 ut-max-w-none lg:ut-max-w-screen-lg md:ut-pt-8 ut-pb-10 md:ut-pb-20">
          <lead-cohorts-header />

          <transition-fade>
            <lead-cohorts-overview v-if="leadsByCohort" :leadsByCohort="leadsByCohort" />
            <loading-spinner v-else />
          </transition-fade>
        </section>

        <section class="ut-flex-grow ut-w-full ut-pb-10 md:ut-pb-20 ut-card-base">
          <lead-cohorts-nav
            :cohorts="leadsByCohort ? leadsByCohort.cohorts : null"
            class="ut-px-4 ut-max-w-none lg:ut-max-w-screen-lg"
          />
        </section>
      </template>
      <template v-else>
        <section class="ut-text-center ut-text-neutral-100">
          <p class="ut-text-sm label-premier-feature">This page is only available to premier agents.</p>
        </section>
      </template>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import LeadCohortsHeader from '@/components/LeadCohorts/LeadCohortsHeader.vue';
import LeadCohortsOverview from '@/components/LeadCohorts/LeadCohortsOverview.vue';
import LeadCohortsNav from '@/components/LeadCohorts/LeadCohortsNav.vue';
import LeadCohortBracketType from '@/Mapper/LeadCohortBracketType';
import LoadingSpinner from '@/components/Animations/LoadingSpinner.vue';
import TransitionFade from '@/components/TransitionFade.vue';

export default {
  name: 'LeadCohorts',
  components: {
    LeadCohortsHeader,
    LeadCohortsOverview,
    LeadCohortsNav,
    LoadingSpinner,
    TransitionFade,
  },
  data() {
    return {
      leadsByCohort: null,
    };
  },
  created() {
    this.$apiServices.oa.user.getLeadCohorts(this.$route.params.uk, { sincePremier: true })
      .then(this.setLeadsByCohort, console.error)
      .catch(console.error);
  },
  computed: {
    ...mapGetters('userStore', [
      'isPremier',
    ]),
    leadActivities() {
      return this.leadCohortsData ? this.leadCohortsData.leadActivities : null;
    },
    date30DaysAgo() {
      return moment().startOf('day').subtract(30, 'days');
    },
    date60DaysAgo() {
      return moment().startOf('day').subtract(60, 'days');
    },
    date90DaysAgo() {
      return moment().startOf('day').subtract(90, 'days');
    },
  },
  methods: {
    setLeadsByCohort(res) {
      const [leadCohortsData] = res;
      this.adaptApiResponse(leadCohortsData);

      this.leadsByCohort = {
        cohorts: this.getLeadsByCohort(leadCohortsData.leadActivities),
        totalReferrals: leadCohortsData.totalReferrals,
        totalListingReferrals: leadCohortsData.totalListingReferrals,
        sincePremier: leadCohortsData.sincePremier,
      };
    },
    adaptApiResponse(leadCohortsData) {
      leadCohortsData.leadActivities.forEach((activity) => {
        const ref = activity;
        ref.agent.referralDate = this.adaptDateToIso(ref.agent.referralDate);
        ref.lead.fullAddress = this.adaptFullAddress(ref.lead);
      });
    },
    adaptDateToIso(date) {
      if (date) {
        return `${date}Z`;
      }
      return null;
    },
    adaptFullAddress(lead) {
      const locality = [lead.suburb, lead.state, lead.postCode].join(' ');
      return [lead.streetAddress, locality].join(', ');
    },
    getLeadsByCohort(leads) {
      const leadsByCohort = {
        [LeadCohortBracketType.upTo30]: [],
        [LeadCohortBracketType.upTo60]: [],
        [LeadCohortBracketType.upTo90]: [],
        [LeadCohortBracketType.above90]: [],
        [LeadCohortBracketType.all]: leads,
      };

      leads.forEach((a) => {
        const bracket = this.getLeadBracket(a.agent.referralDate);
        leadsByCohort[bracket].push(a);
      });

      return leadsByCohort;
    },
    getLeadBracket(dateStr) {
      const date = moment(dateStr);
      if (date >= this.date30DaysAgo) {
        return LeadCohortBracketType.upTo30;
      }
      if (date >= this.date60DaysAgo && date < this.date30DaysAgo) {
        return LeadCohortBracketType.upTo60;
      }
      if (date >= this.date90DaysAgo && date < this.date60DaysAgo) {
        return LeadCohortBracketType.upTo90;
      }
      return LeadCohortBracketType.above90;
    },

  },
};
</script>

<style scoped lang="scss">
.label-premier-feature {
  animation: fade-in .3s linear 3s 1 forwards;
  opacity: 0;
}

@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
